import {
  LocalizationProvider,
  DateTimePicker as TimeDatePicker,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import React from "react";
import { Controller } from "react-hook-form";

interface DateTimePickerProps {
  fieldName: string;
  label: string;
  fullWidth?: boolean;
  control: any;
  format?: string;
  error?: boolean;
  helperText?: any;
  isDate?: boolean;
  defaultValue?: string | null | moment.Moment;
  disabled?: boolean;
  InputProps?: object;
  style?: object;
  onChangeFunction?: any;
}

const DateTimePicker: React.FC<DateTimePickerProps> = ({
  fieldName,
  label,
  fullWidth,
  control,
  format,
  error,
  helperText,
  isDate = true,
  defaultValue,
  InputProps = {},
  style,
  disabled = false,
  onChangeFunction,
}) => {
  const dateFormat = format || isDate ? "MM/DD/YYYY" : "MM/DD/YYYY HH:mm";

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Controller
        name={fieldName || ""}
        control={control}
        defaultValue={defaultValue}
        render={({ field }) => (
          <TimeDatePicker
            {...field}
            label={label || ""}
            value={field.value ? moment(field.value) : null}
            format={dateFormat}
            onChange={(date: any) => {
              if (onChangeFunction) {
                const dateValue = onChangeFunction(date, field);
                field.onChange(
                  moment(dateValue, dateFormat).format(
                    isDate ? "YYYY-MM-DD" : "YYYY-MM-DDTHH:mm:ss"
                  )
                );
              } else {
                field.onChange(
                  moment(date, dateFormat).format(
                    isDate ? "YYYY-MM-DD" : "YYYY-MM-DDTHH:mm:ss"
                  )
                );
              }
            }}
            slotProps={{
              textField: {
                fullWidth: fullWidth || true,
                error: error,
                helperText: helperText || "",
                InputProps: {
                  sx: {
                    backgroundColor: "#f2f4fb",
                    "& fieldset": {
                      borderColor: "#ebebec",
                    },
                    height: 38,
                    ...style,
                  },
                },
                InputLabelProps: {
                  sx: {
                    top: "-9px",
                  },
                },
              },
            }}
            {...InputProps}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default DateTimePicker;
